import React from "react";
import { VideoAsset } from "@/src/components/VideoAsset";
import { Skeleton } from "@/src/components/skeletons/components/Skeleton";
import clsx from "clsx";
import Image from "next/image";

type Props = {
  children?: React.ReactNode;
  className?: string;
  showFallbackImage?: boolean;
};

export function LoadingOrdersView({
  children,
  className,
  showFallbackImage,
}: Props) {
  return (
    <div
      className="flex flex-col gap-3 justify-center items-center"
      data-testid="loading_icon"
    >
      {showFallbackImage ? (
        <Image
          src={"/videos/orders/Cube_Loading_05_fallback_img.png"}
          alt={"cube loading"}
          className={clsx(className ?? "max-w-32")}
          width={127}
          height={127}
        />
      ) : (
        <VideoAsset
          src={"/videos/orders/Cube_Loading_05.mp4"}
          className={clsx(
            className ?? "h-[100px] w-[100px] md:h-[120] md:w-[120] text-md",
          )}
          data-testid="loading_video"
        />
      )}
      {children}
    </div>
  );
}

function LoadingOrdersViewSkeleton() {
  return (
    <LoadingOrdersView>
      <Skeleton className="block h-6 w-36" />
    </LoadingOrdersView>
  );
}

LoadingOrdersView.Skeleton = LoadingOrdersViewSkeleton;
